import { render, staticRenderFns } from "./TheAggregatedViewProducts.vue?vue&type=template&id=367d157b&scoped=true"
import script from "./TheAggregatedViewProducts.vue?vue&type=script&lang=js"
export * from "./TheAggregatedViewProducts.vue?vue&type=script&lang=js"
import style0 from "./TheAggregatedViewProducts.vue?vue&type=style&index=0&id=367d157b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "367d157b",
  null
  
)

export default component.exports